import React, { useState } from "react";
import axios from "axios";

const useBillPaymentGradeClassStudent = ({
    onFinish = ({ axiosMode, status, values }) => { }, //{ axiosMode, status, values }
    onBefore = () => { }, //{ axiosMode, status }
}) => {
    const mainApi = `/cramSchool/api/bill_payment_grade_class_student`
    const [crossHolidayData, setCrossHolidayData] = useState([])
    const [serialCrossHolidayData, setSerialCrossHolidayData] = useState([])
    const [data, setData] = useState([])
    const [option, setOption] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const getBillPaymentGradeClassStudentPdf = async ({
        bill_payment_grade_class_id,
        grade_class_student_id,
        bill_payment_id,
        year,
        year_serial,
        selectDate
    }) => {


        setIsLoading(true)
        return await axios.post(mainApi + '_pdf', {
            bill_payment_grade_class_id,
            grade_class_student_id,
            bill_payment_id,
            year,
            year_serial,
            selectDate
        }, {
            responseType: 'blob'
        })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `繳費單.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                setIsLoading(false)

            });
    }

    const getCrossHoliday = ({
        cur_page,
        size,
        grade_class_id, //必填
    }) => {

        axios.get(`/cramSchool/api/check/cross_holiday`, {
            params: {
                cur_page,
                size,
                grade_class_id
            },
        })
            .then((response) => {
                let data = response.data
                setCrossHolidayData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }

            });
    }
    const getSerialDateCrossHoliday = ({
        cur_page,
        size,
        grade_class_id, //必填
        start_time,
        end_time,
    }) => {

        axios.get(`/cramSchool/api/check/serial_date_cross_holiday`, {
            params: {
                cur_page,
                size,
                grade_class_id,
                start_time,
                end_time,
            },
        })
            .then((response) => {
                let data = response.data
                setSerialCrossHolidayData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }

            });
    }
    return {
        crossHolidayData,
        getCrossHoliday,
        serialCrossHolidayData,
        getSerialDateCrossHoliday,
        getBillPaymentGradeClassStudentPdf: getBillPaymentGradeClassStudentPdf,
        isLoading: isLoading
    }

}
export { useBillPaymentGradeClassStudent }